import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, as: Tag = "h1" }) => {
  const MotionTag = motion.create(Tag);
  return (
    <MotionTag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.1, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};

export const Chapter = ({ number, title, children }) => (
  <Reveal className="group border-t border-line py-10 md:py-14 grid md:grid-cols-12 gap-6 items-baseline">
    <span className="font-mono text-xs text-stone2 tracking-[0.3em] md:col-span-2">{number}</span>
    <h3 className="font-serif text-2xl md:text-4xl font-light tracking-tight md:col-span-4 group-hover:italic transition-all duration-500">{title}</h3>
    <p className="text-sm md:text-base text-stone2 leading-relaxed md:col-span-6 max-w-xl">{children}</p>
  </Reveal>
);
